<template>
    <div class="p-3">
        <el-card header="Lugares de propagandas">
            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
            ]" :data="data" >
                <el-table-column label="Adicionado por" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{data.row.user.name}}
                    </template>
                </el-table-column>
                <el-table-column label="Adicionado em" class-name="auto" :min-width="100">
                    <template #default="data">
                        {{new Date(data.row.created_at).toLocaleString()}}
                    </template>
                </el-table-column>
                <el-table-column label="Activo" class-name="auto" :min-width="60">
                    <template #default="data">
                        {{ data.row.active ? "Sim":"Não" }}
                    </template>
                </el-table-column>
                <el-table-column label="Localização" class-name="auto" :min-width="100">
                    <template #default="data">
                        {{data.row.area.name}}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" :min-width="150">
                    <template #default="data">
                        <span class="d-inline-block p-1">
                            <el-button type="primary" tag="router-link" :to="'/places/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                        <span class="d-inline-block p-1">
                            <el-button v-if="data.row.active" plain :loading="data.row.loading" @click="remove(data)" type="warning" icon="RemoveFilled" title="Desativa"></el-button>
                            <el-button v-else plain :loading="data.row.loading" @click="remove(data)" type="success" icon="Select" title="Activar"></el-button>
                        </span>

                        <span class="p-2" v-if="!data.row.featured">
                            <el-button :loading="data.row.loading" @click="() => featured(data.row)" type="success" title="Destacar" icon="Upload"></el-button>
                        </span>
                        <span class="p-2" v-else>
                            <el-button :loading="data.row.loading" @click="() => featured(data.row)" type="warning" title="Despromover" icon="Download"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import { useStore } from 'vuex';

    const loading = ref<boolean>(true)
    const data = ref<Array<any>>()

    const getPlaces = async () => {
        const res = await Api.get('admin/ads')
        if (res.status == 200) {
            data.value = res.data.ads
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    onBeforeMount(async () => {
        await getPlaces()
        loading.value = false
    })

    const remove = async (_data: any) => {
        _data.row.loading = true
        const res = await Api.delete('admin/ads/' + _data.row.id)
        if (![200].includes(res.status)) {
            ElMessage.error({message: 'Ocorreu um erro ao eliminar ' + _data.row.name})
        } else {
            ElMessage.success({message: 'Atualizado ' + _data.row.name})
            if (data.value) {
                console.log(res.data)
                data.value[_data.$index] = res.data.ad
            }
            // data.value?.splice(_data.$index, 1)
        }
        _data.row.loading = false
        console.log(_data.$index)
    }

    const store = useStore()
    store.watch((s, g) => g.openModal, async (n, o) => {
        o == 3 && await getPlaces()
    })

    const featured = async (row: any) => {
        row.loading = true
        const res = await Api.put(`admin/featured/ad/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.featured = !row.featured
        }
        row.loading = false
    }
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
